import { CardDesignTokens } from '@primeuix/themes/aura/card';

export const cardTokens: CardDesignTokens = {
  root: {
    background: '{content.background}',
    borderRadius: '{border.radius.md}',
    shadow: 'inset 0 0 0 1px {content.border.color}',
    color: '{content.color}',
  },
  body: {
    padding: '1rem',
    gap: '1rem',
  },
  caption: {
    gap: '1rem',
  },
  title: {
    fontSize: '1.125rem',
    fontWeight: '700',
  },
  subtitle: {
    color: '{text.muted.color}',
  },
};
